import { animate, inView, stagger } from 'motion'

export default () => ({
  mapSequence: [
    [
      '.map-marker',
      { opacity: [0, 1], y: ['-50%', 0] },
      { duration: 0.7, delay: stagger(0.1) },
    ],
    ['.map-route', { opacity: [0, 1] }, { duration: 0.2 }],
  ],

  checkPrefersReducedMotion() {
    return !window.matchMedia('(prefers-reduced-motion: no-preference)').matches
  },

  init() {
    if (this.checkPrefersReducedMotion()) {
      return
    }

    animate('.map-marker', { opacity: 0, y: '-50%' }, { duration: 0 })
    animate('.map-route', { opacity: 0 }, { duration: 0 })

    inView(
      '.servicepunten',
      (element) => {
        animate(this.mapSequence)
      },
      { amount: 0.5 },
    )

    animate('.article__image-wrapper', { opacity: 0 }, { duration: 0 })

    inView(
      'article',
      (element) => {
        animate(
          element.querySelector('.article__image-wrapper'),
          { opacity: [0, 1] },
          { duration: 0.6 },
        )
      },
      { amount: 0.5 },
    )
  },
})
